import { initializeApp } from "firebase/app";

import {
	getDatabase,
	ref,
	onValue,
	off,
	set,
	push,
	query,
	get,
	child,
	orderByChild,
	limitToFirst,
	limitToLast,
} from "firebase/database";

import {
	setResultsData,
	addToTeamsData,
	setTeamsData,
} from "store/database/actions";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_APP_ID,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export const createResultsByMilisecondsListener = async ({ gameId, count }) => {
	await onValue(
		query(
			ref(database, `/results/${gameId}`),
			orderByChild("miliseconds"),
			limitToFirst(count)
		),
		(snapshot) => {
			const resultsArr = [];
			snapshot.forEach((result) => {
				resultsArr.push({ ...result.val(), id: result.key });
			});
			setResultsData(gameId, resultsArr);
		}
	);
};

export const createResultsByReversedMilisecondsListener = async ({ gameId, count }) => {
	await onValue(
		query(
			ref(database, `/results/${gameId}`),
			orderByChild("miliseconds"),
			limitToLast(count)
		),
		(snapshot) => {
			const resultsArr = [];
			snapshot.forEach((result) => {
				resultsArr.push({ ...result.val(), id: result.key });
			});
			resultsArr.reverse();
			setResultsData(gameId, resultsArr);
		}
	);
};

export const createResultsByPointsListener = async ({ gameId, count }) => {
	await onValue(
		query(
			ref(database, `/results/${gameId}`),
			orderByChild("points"),
			limitToLast(count)
		),
		(snapshot) => {
			const resultsArr = [];
			snapshot.forEach((result) => {
				resultsArr.push({ ...result.val(), id: result.key });
			});
			resultsArr.reverse();
			setResultsData(gameId, resultsArr);
		}
	);
};

export const createResultsByMetersListener = async ({ gameId, count }) => {
	await onValue(
		query(
			ref(database, `/results/${gameId}`),
			orderByChild("meters"),
			limitToLast(count)
		),
		(snapshot) => {
			const resultsArr = [];
			snapshot.forEach((result) => {
				resultsArr.push({ ...result.val(), id: result.key });
			});
			resultsArr.reverse();
			setResultsData(gameId, resultsArr);
		}
	);
};

export const createTeamsListener = async () => {
	await onValue(query(ref(database, `/teams`)), (snapshot) => {
		setTeamsData(snapshot.val());
	});
};

export const getTeamData = async ({ teamId }) => {
	await get(ref(database, `/teams/${teamId}`)).then((snapshot) => {
		addToTeamsData(teamId, snapshot.val());
	});
};
